import React from "react";

function About() {
  return (
    <section id="about" className="about-section about-style-4">
      <div className="container">
        <div className="row align-items-center">
          {/* LEFT */}
          <div className="col-xl-5 col-lg-6">
            <div className="about-content-wrapper">
              <div className="section-title mb-30">
                <h3 className="mb-25 wow fadeInUp" data-wow-delay=".2s">
                  The future of Learning starts here
                </h3>

                <p className="wow fadeInUp" data-wow-delay=".3s">
                  Welcome to Eduskillprep, our premier destination for
                  comprehensive test preparation, homework help, and academic
                  tutoring services. With a steadfast commitment to academic
                  excellence and student success, we are dedicated to empowering
                  individuals to achieve their academic goals and unlock their
                  full potential.
                </p>
              </div>

              <ul>
                <li className="wow fadeInUp" data-wow-delay=".35s">
                  <i className="lni lni-checkmark-circle"></i>
                  One-on-one tutoring designed to match each student's pace,
                  strengths, and goals.
                </li>

                <li className="wow fadeInUp" data-wow-delay=".4s">
                  <i className="lni lni-checkmark-circle"></i>
                  Live video classes with experienced tutors for real-time
                  interaction and feedback.
                </li>

                <li className="wow fadeInUp" data-wow-delay=".45s">
                  <i className="lni lni-checkmark-circle"></i>
                  Complete study resources with practice tests, assignments,
                  sectional tests, and mock exams.
                </li>
              </ul>

              <a
                style={{ backgroundColor: "#3b52ff" }}
                href="#contact"
                className="button button-lg radius-10 wow fadeInUp"
                data-wow-delay=".5s"
              >
                Learn More
              </a>
            </div>
          </div>

          {/* RIGHT */}
          <div className="col-xl-7 col-lg-6">
            <div
              className="about-image text-lg-right wow fadeInUp"
              data-wow-delay=".5s"
            >
              <img src="/assets/img/about/about-img.svg" alt="about" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
